export default "__VITE_ASSET__BvpqRGZp__"